/* eslint-disable max-lines */
export const Colors = {
  baseBrand50: '#00111b',
  baseBrand100: '#011928',
  baseBrand200: '#033250',
  baseBrand300: '#044B77',
  baseBrand400: '#06649F',
  baseBrand500: '#077DC7',
  baseBrand600: '#2D92D2',
  baseBrand700: '#53A8DD',
  baseBrand800: '#7ABDE7',
  baseBrand900: '#8DC8ED',
  baseSteel50: '#e8198a',
  baseSteel100: '#e8198a',
  baseSteel200: '#e8198a',
  baseSteel300: '#e8198a',
  baseSteel400: '#e8198a',
  baseSteel500: '#BCBEC3',
  baseSteel600: '#e8198a',
  baseSteel700: '#e8198a',
  baseSteel800: '#e8198a',
  baseSteel900: '#ffffff',
  baseGray50: '#e8198a',
  baseGray100: '#e8198a',
  baseGray200: '#e8198a',
  baseGray300: '#1B1C1E',
  baseGray400: '#e8198a',
  baseGray500: '#e8198a',
  baseGray600: '#46454B',
  baseGray700: '#e8198a',
  baseGray800: '#e8198a',
  baseGray900: '#e8198a',
  baseBlue50: '#00111b',
  baseBlue100: '#011928',
  baseBlue200: '#033250',
  baseBlue300: '#044B77',
  baseBlue400: '#044B77',
  baseBlue500: '#077DC7',
  baseBlue600: '#2D92D2',
  baseBlue700: '#53A8DD',
  baseBlue800: '#7ABDE7',
  baseBlue900: '#8DC8ED',
  baseGreen50: '#001009',
  baseGreen100: '#001C10',
  baseGreen200: '#003720',
  baseGreen300: '#005330',
  baseGreen400: '#006E40',
  baseGreen500: '#008A50',
  baseGreen600: '#1AA168',
  baseGreen700: '#33B981',
  baseGreen800: '#4DD099',
  baseGreen900: '#5ADCA5',
  baseRed50: '#120100',
  baseRed100: '#220300',
  baseRed200: '#61201B',
  baseRed300: '#882D25',
  baseRed400: '#AE3A30',
  baseRed500: '#D4473B',
  baseRed600: '#DD6C62',
  baseRed700: '#E59189',
  baseRed800: '#EEB5B1',
  baseRed900: '#F2C8C4',
  baseYellow50: '#140b00',
  baseYellow100: '#221400',
  baseYellow200: '#533409',
  baseYellow300: '#70460D',
  baseYellow400: '#8E5910',
  baseYellow500: '#AB6B13',
  baseYellow600: '#D49B4C',
  baseYellow700: '#f6c785',
  baseYellow800: '#ffdfb1',
  baseYellow900: '#ffedd6',
  interactivePrimaryDefault: '#077DC7',
  interactivePrimaryActive: '#077DC7',
  interactivePrimaryHover: '#2D92D2',
  interactivePrimaryPressed: '#53A8DD',
  interactiveSuccessDefault: '#008A50',
  interactiveSuccessHover: '#1AA168',
  interactiveSuccessPressed: '#33B981',
  interactiveSuccessActive: '#33B981',
  interactiveSuccessDisabled: '#005330',
  interactiveWarningDefault: '#AB6B13',
  interactiveWarningHover: '#D49B4C',
  interactiveWarningPressed: '#f6c785',
  interactiveCriticalDefault: '#D4473B',
  interactiveCriticalHover: '#DD6C62',
  interactiveCriticalPressed: '#E59189',
  interactiveInfoDefault: '#077DC7',
  interactiveInfoHover: '#2D92D2',
  interactiveInfoPressed: '#53A8DD',
  interactiveNeutralDefault: '#e8198a',
  interactiveNeutralHover: '#e8198a',
  interactiveNeutralPressed: '#46454B',
  interactiveNeutralDisabled: '#e8198a',
  backgroundViewDarker: '#e8198a',
  backgroundViewHoverBackground: '#00111b',
  backgroundViewLighter: '#e8198a',
  backgroundViewLight: '#e8198a',
  backgroundViewApp: '#1B1C1E',
  backgroundViewHover: '#e8198a',
  backgroundViewNavi: '#e8198a',
  backgroundSystemInfoLight: '#e8198a',
  backgroundSystemInfoDefault: '#011928',
  backgroundSystemCritcal: '#220300',
  backgroundSystemWarning: '#221400',
  backgroundSystemSuccess: '#001C10',
  backgroundPrivateDefault: '#e8198a',
  backgroundPrivateLight: '#e8198a',
  backgroundPrivateDark: '#e8198a',
  backgroundGradientBrand: 'linear-gradient(270deg, #e8198a 0%, #e8198a 100%)',
  backgroundGradientNeutral: 'linear-gradient(180deg, #e8198a 0%, #e8198a 100%)',
  backgroundGradientLead: 'linear-gradient(45deg, #e8198a 0%, #e8198a 50%, #e8198a 100%)',
  backgroundGradientScale: 'linear-gradient(45deg, #e8198a 0%, #e8198a 50%, #e8198a 100%)',
  backgroundGradientLaunch: 'linear-gradient(45deg, #e8198a 0%, #e8198a 50%, #e8198a 100%)',
  backgroundGradientPurple: 'linear-gradient(-90deg, #e8198a 30%, #e8198a 70%)',
  backgroundGradientOrange: 'linear-gradient(90deg, #e8198a 27.46%, #e8198a 100%)',
  backgroundGradientRed: 'linear-gradient(90deg, #e8198a 27.46%, #e8198a 100%)',
  backgroundGradientLightBlue: 'linear-gradient(45deg, #e8198a 0%, #e8198a 100%)',
  backgroundGradientVideo:
    'linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)',
  backgroundGradientVideoOverlay:
    'linear-gradient(45deg, rgba(#e8198a, 0.7) 0%, rgba(#e8198a, 0.7) 52%, rgba(#e8198a, 0.7) 100%)',
  backgroundGradientFindTimeGray:
    'repeating-linear-gradient(135deg, #e8198a, #e8198a 6px, #e8198a 6px, #e8198a 12px)',
  backgroundGradientFindTimeBlue:
    'repeating-linear-gradient(135deg, #e8198a, #e8198a 6px, #e8198a 6px, #e8198a 12px)',
  backgroundGradientFindTimeViolet:
    'repeating-linear-gradient(135deg, #e8198a, #e8198a 6px, #e8198a 6px, #e8198a 12px)',
  backgroundGradientMask:
    'linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%',
  backgroundGradientRainbow:
    'linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)',
  backgroundGradientGrayToTransparent:
    'linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)',
  borderNeutralDefault: '#46454B',
  borderNeutralDark: '#e8198a',
  borderNeutralDisabled: '#e8198a',
  borderSystemInfo: '#077DC7',
  borderSystemSuccess: '#008A50',
  borderSystemCritical: '#D4473B',
  borderSystemWarning: '#AB6B13',
  borderMainPrimary: '#077DC7',
  textSystemInfo: '#2D92D2',
  textSystemSuccess: '#1AA168',
  textSystemWarning: '#D49B4C',
  textSystemCritical: '#DD6C62',
  textMainDefault: '#ffffff',
  textMainSubdued: '#BCBEC3',
  textMainDisabled: '#e8198a',
  iconSystemInfo: '#077DC7',
  iconSystemSuccess: '#008A50',
  iconSystemWarning: '#AB6B13',
  iconSystemCritical: '#D4473B',
  iconMainBrand: '#077DC7',
  iconMainDefault: '#ffffff',
  iconMainSubdued: '#BCBEC3',
  iconMainDisabled: '#e8198a',
  miscSpecialPersonal: '#e8198a',
  miscSpecialOrangeLight: '#e8198a',
  miscSpecialViolet: '#e8198a',
  miscSpecialOrange: '#e8198a',
  miscSpecialYellow: '#e8198a',
  miscSpecialIndigo: '#e8198a',
  miscSpecialDarkYellow: '#e8198a',
  miscSpecialDarkBlue: '#e8198a',
  miscSpecialLime: '#e8198a',
  miscSocialFacebook: '#e8198a',
  miscSocialTwitter: '#e8198a',
  miscSocialGooglePlus: '#e8198a',
  miscSocialLinkedin: '#e8198a',
  pricingScaleDefault: '#e8198a',
  pricingScaleHover: '#e8198a',
  pricingScaleSubdued: '#e8198a',
  pricingLeadDefault: '#e8198a',
  pricingLeadHover: '#e8198a',
  pricingLeadSubdued: '#e8198a',
  white: '#ffffff',
  black: '#e8198a',
  colorBgDefault: '#222326',
  colorBgHover: '#e8198a',
  colorBgActive: '#011928',
  colorBgDisabled: '#46454B',
  colorBgSelected: '#011928',
  colorBgPrimaryDefault: '#077DC7',
  colorBgPrimaryHover: '#2D92D2',
  colorBgPrimaryPressed: '#53A8DD',
  colorBgPrimarySelected: '#077DC7',
  colorBgPrimarySubduedHover: '#00111b',
  colorBgPrimarySubduedSelected: '#00111b',
  colorBgPrimarySubduedActive: '#00111b',
  colorBgPrimaryStrongDefault: '#2D92D2',
  colorBgNeutralDefault: '#1B1C1E',
  colorBgNeutralHover: '#e8198a',
  colorBgNeutralPressed: '#46454B',
  colorBgNeutralDisabled: '#e8198a',
  colorBgNeutralSelected: '#e8198a',
  colorBgNeutralLowDefault: '#e8198a',
  colorBgNeutralLowHover: '#e8198a',
  colorBgNeutralLowDisabled: '#1B1C1E',
  colorBgNeutralStrongDefault: '#46454B',
  colorBgNeutralStrongHover: '#e8198a',
  colorBgSuccessDefault: '#008A50',
  colorBgSuccessHover: '#1AA168',
  colorBgSuccessPressed: '#33B981',
  colorBgSuccessDisabled: '#005330',
  colorBgSuccessLowDefault: '#001C10',
  colorBgSuccessLowHover: '#001C10',
  colorBgSuccessLowPressed: '#001C10',
  colorBgCriticalDefault: '#D4473B',
  colorBgCriticalHover: '#DD6C62',
  colorBgCriticalPressed: '#E59189',
  colorBgCriticalLowDefault: '#220300',
  colorBgCriticalLowHover: '#220300',
  colorBgCriticalLowPressed: '#220300',
  colorBgCriticalStrongDefault: '#DD6C62',
  colorBgCriticalStrongActive: '#E59189',
  colorBgWarningDefault: '#AB6B13',
  colorBgWarningHover: '#D49B4C',
  colorBgWarningPressed: '#f6c785',
  colorBgWarningLowDefault: '#221400',
  colorBgWarningLowHover: '#221400',
  colorBgWarningLowPressed: '#221400',
  colorBgScaleDefault: '#e8198a',
  colorBgScaleHover: '#e8198a',
  colorBgScaleSubduedDefault: '#e8198a',
  colorBgLeadDefault: '#e8198a',
  colorBgLeadHover: '#e8198a',
  colorBgLeadSubduedDefault: '#e8198a',
  colorBgPrivateDefault: '#e8198a',
  colorBgPrivateHover: '#e8198a',
  colorBgPrivateStrongDefault: '#e8198a',
  colorBgPrivateLowDefault: '#e8198a',
  colorBgGradientSubdued: 'linear-gradient(180deg, #e8198a 0%, #e8198a 100%)',
  colorBgSecondaryDefault: '#BCBEC3',
  colorBgSecondaryDisabled: '#e8198a',
  colorBgSecondaryStrongDefault: '#ffffff',
  colorBgSecondaryStrongHover: '#e8198a',
  colorBgSecondaryStrongPressed: '#e8198a',
  colorBgSecondaryStrongActive: '#e8198a',
  colorBgSecondarySubduedDefault: '#e8198a',
  colorBgSecondaryLowDefault: '#e8198a',
  colorBgSecondaryLowDisabled: '#e8198a',
  colorBgInfoDefault: '#077DC7',
  colorBgInfoStrongDefault: '#2D92D2',
  colorBgInfoLowDefault: '#011928',
  colorBgInfoLowHover: '#011928',
  colorBgInfoLowPressed: '#011928',
  colorBgOverdueDefault: '#e8198a',
  colorBgOverdueLowDefault: '#e8198a',
  colorBgNoconsentDefault: '#e8198a',
  colorBgNodataDefault: '#e8198a',
  colorBgTeamDefault: '#e8198a',
  colorBgPersonalDefault: '#e8198a',
  colorBgOverlayDefault: 'rgba(36,38,46,0.7)',
  colorBgOnoverlayHover: 'rgba(255,255,255,0.1)',
  colorBgOnoverlayPressed: 'rgba(255,255,255,0.2)',
  colorBgGhostHover: 'rgba(255,255,255,0.1)',
  colorBgGhostPressed: 'rgba(255,255,255,0.2)',
  colorBgTintDefault: 'rgba(255,255,255,0.3)',
  colorBgLoadingDefault: 'rgba(255,255,255,0.15)',
  colorBgOfferDefault: '#e8198a',
  colorBgScreeningDefault: '#033250',
  colorBgInterviewDefault: '#077DC7',
  colorBgEvaluationDefault: '#53A8DD',
  colorBgHiredDefault: '#008A50',
  colorBgTranslateDefault: '#AB6B13',
  colorBgChartDefault: 'rgba(25, 153, 227, 0.1)',
  colorTextDefault: '#BCBEC3',
  colorTextHover: '#ffffff',
  colorTextPressed: '#ffffff',
  colorTextDisabled: '#e8198a',
  colorTextStrongDefault: '#ffffff',
  colorTextStrongHover: '#ffffff',
  colorTextStrongSelected: '#ffffff',
  colorTextLowDefault: '#e8198a',
  colorTextOnprimaryDefault: '#ffffff',
  colorTextOnprimaryHover: '#ffffff',
  colorTextOnprimaryPressed: '#ffffff',
  colorTextOnprimaryDisabled: '#ffffff',
  colorTextOnprimarySelected: '#ffffff',
  colorTextOnneutralDisabled: '#ffffff',
  colorTextOnsuccessDefault: '#ffffff',
  colorTextOnsuccessHover: '#ffffff',
  colorTextOnsuccessPressed: '#ffffff',
  colorTextOncriticalDefault: '#ffffff',
  colorTextOncriticalHover: '#ffffff',
  colorTextOncriticalPressed: '#ffffff',
  colorTextOnwarningDefault: '#ffffff',
  colorTextOnwarningHover: '#ffffff',
  colorTextOnwarningPressed: '#ffffff',
  colorTextSuccessDefault: '#008A50',
  colorTextSuccessHover: '#008A50',
  colorTextSuccessPressed: '#1AA168',
  colorTextSuccessStrongDefault: '#1AA168',
  colorTextCriticalDefault: '#D4473B',
  colorTextCriticalHover: '#D4473B',
  colorTextCriticalPressed: '#DD6C62',
  colorTextCriticalStrongDefault: '#DD6C62',
  colorTextInfoDefault: '#077DC7',
  colorTextInfoHover: '#077DC7',
  colorTextInfoPressed: '#2D92D2',
  colorTextInfoStrongDefault: '#2D92D2',
  colorTextWarningDefault: '#AB6B13',
  colorTextWarningHover: '#AB6B13',
  colorTextWarningPressed: '#D49B4C',
  colorTextWarningStrongDefault: '#D49B4C',
  colorTextOnscaleDefault: '#ffffff',
  colorTextOnscaleHover: '#ffffff',
  colorTextOnleadDefault: '#ffffff',
  colorTextOnleadHover: '#ffffff',
  colorTextScaleDefault: '#e8198a',
  colorTextScaleHover: '#e8198a',
  colorTextOngradientDefault: '#ffffff',
  colorTextLeadDefault: '#e8198a',
  colorTextOnsecondaryDefault: '#ffffff',
  colorTextOnsecondaryStrongDefault: '#ffffff',
  colorTextOnsecondaryStrongHover: '#ffffff',
  colorTextOnsecondaryStrongPressed: '#ffffff',
  colorTextOninfoStrongDefault: '#ffffff',
  colorTextOverdueDefault: '#e8198a',
  colorTextOnoverdueDefault: '#ffffff',
  colorTextNoconsentDefault: '#e8198a',
  colorTextNodataDefault: '#e8198a',
  colorTextOnoverlayDefault: '#ffffff',
  colorTextOnoverlayHover: '#ffffff',
  colorTextOnoverlayPressed: '#ffffff',
  colorTextOnoverlayDisabled: '#e8198a',
  colorTextOnoverlayLowDefault: '#e8198a',
  colorTextOnghostDefault: '#ffffff',
  colorTextOnghostHover: '#ffffff',
  colorTextOnghostPressed: '#ffffff',
  colorTextOnghostDisabled: '#e8198a',
  colorTextPrimaryDefault: '#077DC7',
  colorTextPrimaryActive: '#077DC7',
  colorTextPrimaryHover: '#2D92D2',
  colorTextPrimaryStrongDefault: '#2D92D2',
  colorTextOnteamDefault: '#ffffff',
  colorTextOncomponentDefault: '#ffffff',
  colorIconDefault: '#BCBEC3',
  colorIconHover: '#ffffff',
  colorIconPressed: '#ffffff',
  colorIconDisabled: '#e8198a',
  colorIconStrongDefault: '#ffffff',
  colorIconOnprimaryDefault: '#ffffff',
  colorIconOnprimaryHover: '#ffffff',
  colorIconOnprimaryPressed: '#ffffff',
  colorIconOnprimaryDisabled: '#ffffff',
  colorIconOnneutralDisabled: '#ffffff',
  colorIconOnsuccessDefault: '#ffffff',
  colorIconOnsuccessHover: '#ffffff',
  colorIconOnsuccessPressed: '#ffffff',
  colorIconOnsuccessDisabled: '#ffffff',
  colorIconOncriticalDefault: '#ffffff',
  colorIconOncriticalHover: '#ffffff',
  colorIconOncriticalPressed: '#ffffff',
  colorIconOnwarningDefault: '#ffffff',
  colorIconOnwarningHover: '#ffffff',
  colorIconOnwarningPressed: '#ffffff',
  colorIconSuccessDefault: '#008A50',
  colorIconSuccessHover: '#008A50',
  colorIconSuccessPressed: '#1AA168',
  colorIconSuccessActive: '#33B981',
  colorIconSuccessStrongDefault: '#1AA168',
  colorIconCriticalDefault: '#D4473B',
  colorIconCriticalHover: '#D4473B',
  colorIconCriticalPressed: '#DD6C62',
  colorIconCriticalStrongDefault: '#DD6C62',
  colorIconInfoDefault: '#077DC7',
  colorIconInfoHover: '#077DC7',
  colorIconInfoPressed: '#2D92D2',
  colorIconInfoStrongDefault: '#2D92D2',
  colorIconWarningDefault: '#AB6B13',
  colorIconWarningHover: '#AB6B13',
  colorIconWarningPressed: '#D49B4C',
  colorIconWarningStrongDefault: '#D49B4C',
  colorIconScaleDefault: '#e8198a',
  colorIconScaleHover: '#e8198a',
  colorIconOngradientDefault: '#ffffff',
  colorIconOnscaleDefault: '#ffffff',
  colorIconOnscaleHover: '#ffffff',
  colorIconLeadDefault: '#e8198a',
  colorIconOnleadDefault: '#ffffff',
  colorIconOnleadHover: '#ffffff',
  colorIconOnsecondaryDefault: '#ffffff',
  colorIconOnsecondaryStrongDefault: '#ffffff',
  colorIconOnsecondaryStrongHover: '#ffffff',
  colorIconOninfoStrongDefault: '#ffffff',
  colorIconOverdueDefault: '#e8198a',
  colorIconOnoverdueDefault: '#ffffff',
  colorIconNoconsentDefault: '#e8198a',
  colorIconNodataDefault: '#e8198a',
  colorIconOnoverlayDefault: '#ffffff',
  colorIconOnoverlayHover: '#ffffff',
  colorIconOnoverlayPressed: '#ffffff',
  colorIconOnoverlayDisabled: '#e8198a',
  colorIconOnghostDefault: '#ffffff',
  colorIconOnghostHover: '#ffffff',
  colorIconOnghostPressed: '#ffffff',
  colorIconOnghostDisabled: '#e8198a',
  colorIconPrimaryDefault: '#077DC7',
  colorIconPrimaryHover: '#2D92D2',
  colorIconPrimaryPressed: '#077DC7',
  colorIconPrimaryStrongDefault: '#2D92D2',
  colorIconLowDefault: '#e8198a',
  colorIconLowDisabled: '#e8198a',
  colorIconSubduedDefault: '#e8198a',
  colorIconOncomponentDefault: '#ffffff',
  colorBorderDefault: '#46454B',
  colorBorderHover: '#46454B',
  colorBorderPressed: '#46454B',
  colorBorderDisabled: '#e8198a',
  colorBorderSelected: '#46454B',
  colorBorderSuccessDefault: '#008A50',
  colorBorderSuccessHover: '#008A50',
  colorBorderSuccessPressed: '#1AA168',
  colorBorderSuccessSubduedDefault: '#003720',
  colorBorderCriticalDefault: '#D4473B',
  colorBorderCriticalHover: '#D4473B',
  colorBorderCriticalPressed: '#DD6C62',
  colorBorderCriticalLowDefault: '#882D25',
  colorBorderCriticalSubduedDefault: '#61201B',
  colorBorderInfoDefault: '#077DC7',
  colorBorderInfoHover: '#077DC7',
  colorBorderInfoPressed: '#2D92D2',
  colorBorderInfoSubduedDefault: '#033250',
  colorBorderWarningDefault: '#AB6B13',
  colorBorderWarningHover: '#AB6B13',
  colorBorderWarningPressed: '#D49B4C',
  colorBorderWarningSubduedDefault: '#533409',
  colorBorderNeutralHover: '#e8198a',
  colorBorderNeutralDisabled: '#1B1C1E',
  colorBorderOncomponentDefault: '#ffffff',
  colorBorderSecondaryDefault: '#BCBEC3',
  colorBorderSecondaryHover: '#ffffff',
  colorBorderSecondaryLowDefault: '#e8198a',
  colorBorderSecondaryLowDisabled: '#e8198a',
  colorBorderSecondaryStrongDefault: '#e8198a',
  colorBorderPrimaryDefault: '#077DC7',
  colorBorderPrimaryHover: '#2D92D2',
  colorBorderPrimaryStrongDefault: '#2D92D2',
  colorBorderPrimarySubduedDefault: '#033250',
  colorBorderTranslateDefault: '#AB6B13',
  colorBorderOnghostDefault: '#ffffff',
  colorBorderOnghostHover: '#ffffff',
  colorBorderOnghostPressed: '#ffffff',
  colorBorderOnghostDisabled: '#e8198a',
  colorBorderPrivateDefault: '#e8198a',
  colorBorderStrongDefault: '#e8198a',
  colorBorderStrongDisabled: '#e8198a',
  colorBorderLowDefault: '#e8198a',
  colorBorderLowHover: '#e8198a',
  colorBorderTeamDefault: '#e8198a',
  colorGradientPrimary: 'linear-gradient(270deg, #e8198a 0%, #e8198a 100%)',
  colorGradientLaunch: 'linear-gradient(45deg, #e8198a 0%, #e8198a 50%, #e8198a 100%)',
  colorGradientScale: 'linear-gradient(45deg, #e8198a 0%, #e8198a 50%, #e8198a 100%)',
  colorGradientLead: 'linear-gradient(45deg, #e8198a 0%, #e8198a 50%, #e8198a 100%)',
  colorGradientPurple: 'linear-gradient(-90deg, #e8198a 30%, #e8198a 70%)',
  colorGradientOrange: 'linear-gradient(90deg, #e8198a 27.46%, #e8198a 100%)',
  colorGradientRed: 'linear-gradient(90deg, #e8198a 27.46%, #e8198a 100%)',
  colorGradientLightBlue: 'linear-gradient(45deg, #e8198a 0%, #e8198a 100%)',
  colorGradientVideo:
    'linear-gradient(70.48deg, rgba(23,66,152,0.6) 3.87%, rgba(113,72,189,0.6) 53.52%, rgba(175,126,230,0.6) 94.89%)',
  colorGradientVideoOverlay:
    'linear-gradient(45deg, rgba(#e8198a, 0.7) 0%, rgba(#e8198a, 0.7) 52%, rgba(#e8198a, 0.7) 100%)',
  colorGradientFindTimeNeutral:
    'repeating-linear-gradient(135deg, #e8198a, #e8198a 6px, #e8198a 6px, #e8198a 12px)',
  colorGradientFindTimePrimary:
    'repeating-linear-gradient(135deg, #e8198a, #e8198a 6px, #e8198a 6px, #e8198a 12px)',
  colorGradientFindTimeViolet:
    'repeating-linear-gradient(135deg, #e8198a, #e8198a 6px, #e8198a 6px, #e8198a 12px)',
  colorGradientTruncate: '#e8198a00',
  colorGradientShimmer:
    'linear-gradient(-60deg, #e8198a 30%, #e8198a5, #e8198a 70%) right/300% 100%',
  colorGradientRainbow:
    'linear-gradient(90deg, rgb(113, 72, 189) 0%, rgb(202, 139, 219) 7%, rgb(25, 153, 227) 14%, rgb(124, 204, 250) 21%, rgb(125, 212, 122) 27%, rgb(49, 189, 149) 33.33%, rgb(125, 212, 122) 36%, rgb(124, 204, 250) 42%, rgb(25, 153, 227) 47%, rgb(202, 139, 219) 53%, rgb(113, 72, 189) 60%, rgb(25, 153, 227) 66.66%, rgb(123, 204, 250) 100%)',
  colorGradientNeutralToTransparent:
    'linear-gradient(to bottom, rgba(240, 244, 247, 1) 0%, rgba(240, 244, 247, 0) 100%)',
  colorTooltipFeature: '#e8198a',
  colorAvatarSteelLighter: '#e8198a',
  colorAvatarSteelLight: '#e8198a',
  colorAvatarSteelDark: '#BCBEC3',
  colorAvatarGrayLight: '#46454B',
  colorAvatarGrayDark: '#e8198a',
  colorAvatarGreen: '#e8198a',
  colorAvatarBlueLight: '#077DC7',
  colorAvatarBlueDark: '#2D92D2',
  colorAvatarBlueDarker: '#7ABDE7',
  colorAvatarPink: '#e8198a',
  colorAvatarPurple: '#e8198a',
  colorAvatarYellow: '#AB6B13',
  colorAvatarOrange: '#e8198a',
  colorAvatarSkeleton: '#e8198a',
  avatarSteelLighter: '#e8198a',
  avatarSteelLight: '#e8198a',
  avatarSteelDark: '#BCBEC3',
  avatarGrayLight: '#46454B',
  avatarGrayDark: '#e8198a',
  avatarGreen: '#e8198a',
  avatarBlueLight: '#077DC7',
  avatarBlueDark: '#2D92D2',
  avatarBlueDarker: '#7ABDE7',
  avatarPink: '#e8198a',
  avatarPurple: '#e8198a',
  avatarYellow: '#AB6B13',
  avatarOrange: '#e8198a',
  avatarSkeleton: '#e8198a',
};
